<div class="wa-opener">

  @if (messages().length === 0) {
    <p class="wa-opener__empty">No messages available for this breakdown.</p>
  }

  @for (msg of messages(); track $index) {
    <div class="wa-opener__row">
      <div class="wa-opener__text">{{ msg.text }}</div>
      <div class="wa-opener__actions">
        <!-- <button nz-button nzType="default" nzSize="small" (click)="onCopyOnly($index)">
          <span nz-icon nzType="copy" nzTheme="outline"></span>
          Copy
        </button> -->
        @for (btn of msg.buttons; track btn.label) {
          <button nz-button nzType="primary" nzSize="small" (click)="onAppendAndOpen(msg, btn)">
            {{ btn.label }}
          </button>
        }
      </div>
    </div>
  }

  <div class="wa-opener__footer">
    <button nz-button nzType="default" [disabled]="!whatsappLink" (click)="openWhatsApp()">
      <span nz-icon nzType="whats-app" nzTheme="outline"></span>
      Open WhatsApp
    </button>
  </div>

</div>
